/**
 * Main exports for @chipi-stack/nextjs
 * 
 * Client-side components and hooks are exported from this main entry point.
 * Server-side utilities are exported from '@chipi-stack/nextjs/server'.
 */

/**
 * Conditionally export ChipiProvider that exhibits different behavior
 * when used in /app vs /pages router.
 * We define the runtime and type values explicitly,
 * because TS will not recognize the subpath import unless the HOST
 * application sets moduleResolution to 'NodeNext'.
 */
// @ts-ignore
import * as ComponentsModule from '#components';
// LEAVE THE TS IGNORE!!! IMPORTANT NEXTJS BUG

import type { ServerComponentsServerModuleTypes } from './components.server';

export const ChipiProvider = ComponentsModule.ChipiProvider as ServerComponentsServerModuleTypes['ChipiProvider'];

// Individual providers (for advanced use cases)
export { ChipiProvider as ChipiClientProvider } from './app-router/client/ChipiProvider';

// Client-side hooks - these are safe to import because they're marked 'use client'
export * from './hooks';

// Re-export types
export type * from '@chipi-stack/types';

export * from "./server";
